import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Row,
  Col,
  Modal,
  Select,
  Form,
  Alert,
  Card,
  Space,
  Divider,
  Tooltip,
  Tag,

} from "antd";
import cx from "classnames";
import styles from "./styles/OrderDetail.module.css";
import { selectUser } from "../redux/slices/user";
import ProductList from "./ProductList";
import OrderHeader from "./OrderHeader";
import OrderClientInfo from "./OrderClientInfo";
import OrderActionsSection from "./OrderActionsSection";

const OrderDetail = (props) => {
  const [drivers, handleDrivers] = useState([]);
  const [selectDriver, handleSelectedDriver] = useState(null);
  const [selectBranch, handleSelectedBranch] = useState(null);
  const [loading, handleLoading] = useState(true);
  const [sending, handleSending] = useState(false);
  const [assing, handleAssing] = useState(false);
  const [, handleLoadTransfer] = useState(false);
  const [deleting, handleDeleting] = useState(false);
  const [loadingDeta, handleLoadingOrder] = useState(false);
  const user = useSelector(selectUser);
  // const dispatch = useDispatch();
  const isAdmin = user.admin;
  const isDriver = user.driver;
  const [form] = Form.useForm();

  const {
    order,
    monitor,
    acceptOrder,
    updateOrder,
    finishOrder,
    cancelOrder,
    assignOrder,
    sendPeya,
    getDriversBranch,
    branches,
    transferOrder,
    reasons,
    updateManualRemoteId,
    updateKioskoManualStatus
  } = props;

  const {
    branch,
    status,
    platform,
    description,
    orderType,
    id_user,
    id_driver,
    delivery_address,
    address_info,
    discount,
    total,
    ticket,
    peyaOrder,
    products,
    cireba_remote_id,
    payment_method,
    change,
    cashback,
    delivery_fee,
    peyaStatus,
    peyaConfirmCode,
    peyaResult,
    tip,
  } = order;

  const isCash = payment_method === 1;
  const reasonOptions = Array.isArray(reasons)
    ? reasons.map((item) => ({ value: item.id, label: item.name }))
    : [];

  // Mapa simple de colores por nombre
  const colorMap = {
    negro: "#1f1f1f",
    black: "#1f1f1f",
    blanco: "#ffffff",
    white: "#ffffff",
    gris: "#9e9e9e",
    gray: "#9e9e9e",
    plata: "#c0c0c0",
    plateado: "#c0c0c0",
    silver: "#c0c0c0",
    rojo: "#e53935",
    red: "#e53935",
    azul: "#1e88e5",
    blue: "#1e88e5",
    verde: "#43a047",
    green: "#43a047",
    amarillo: "#fdd835",
    yellow: "#fdd835",
    naranja: "#fb8c00",
    orange: "#fb8c00",
    morado: "#8e24aa",
    purple: "#8e24aa",
    marron: "#795548",
    café: "#6d4c41",
    cafe: "#6d4c41",
    beige: "#d7ccc8",
    dorado: "#d4af37",
    celeste: "#4fc3f7",
  };

  const normalizeColor = (input) => {
    if (!input) return undefined;
    const trimmed = String(input).trim();

    // Hex o rgb(a)
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(trimmed)) return trimmed;
    if (/^rgba?\(/i.test(trimmed)) return trimmed;

    const key = trimmed
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "");
    return colorMap[key];
  };

  const ColorSwatch = ({ colorName, size = 14 }) => {
    const hex = normalizeColor(colorName);
    if (!hex) return null;
    return (
      <span
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          display: "inline-block",
          background: hex,
          border: "1px solid rgba(0,0,0,.15)",
          boxShadow: "inset 0 0 0 2px rgba(255,255,255,.6)",
          verticalAlign: "middle",
          marginRight: 6,
        }}
      />
    );
  };

  useEffect(() => {
    const initialFetch = async () => {
      if (monitor && !isDriver && orderType === 2 && !peyaOrder && status >= 7 && status < 11) {
        const newDrivers = await getDriversBranch(branch.id, order.id);
        handleDrivers(newDrivers);
        handleLoading(false);
        if (id_driver) {
          handleSelectedDriver(id_driver.id);
        }
      } else {
        handleLoading(false);
      }
    };
    initialFetch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order]);

  const spanish_peya = {
    CONFIRMED: "CONFIRMADA",
    IN_PROGRESS: "INICIADA",
    NEAR_PICKUP: "LLEGADA SUCURSAL",
    PICKED_UP: "EN CAMINO",
    NEAR_DROPOFF: "POR ENTREGAR",
    COMPLETED: "FINALIZADA",
    NOT_ACCEPTED: "NO ACEPTADO",
    CANCELLED: "CANCELADA"
  };

  const openDataCard = async (id, data) => {
    handleLoadingOrder(true);
    let jsonobj = JSON.parse(data);
    Modal.info({
      title: "JSON Tarjeta - " + id,
      content: (
        <div>
          <pre dangerouslySetInnerHTML={{ __html: syntaxHighlight(jsonobj) }} />
        </div>
      ),
      onOk() { },
    });
    handleLoadingOrder(false);
  };

  const syntaxHighlight = (json) => {
    if (typeof json != "string") {
      json = JSON.stringify(json, undefined, 2);
    }
    json = json
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?)|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g,
      (match) => {
        let cls = "number";
        if (/^"/.test(match)) {
          cls = /:$/.test(match) ? "key" : "string";
        } else if (/true|false/.test(match)) {
          cls = "boolean";
        } else if (/null/.test(match)) {
          cls = "null";
        }
        return `<span class="${cls}">${match}</span>`;
      }
    );
  };

  const confirmModal = (title, content, okText, onOk) => {
    Modal.confirm({
      title,
      content,
      okText,
      cancelText: "Cancelar",
      onOk,
    });
  };

  const confirmCancel = () => {
    form.resetFields();
    Modal.confirm({
      title: "¿Estás segúro de cancelar esta orden?",
      content: (
        <Form layout="vertical" form={form}>
          <p>Esta acción no se podrá deshacer.</p>
          <Form.Item
            label="Seleccione la razón de cancelación:"
            name="reason"
            rules={[{ required: true, message: "Por favor seleccione una razón" }]}
          >
            <Select
              options={reasonOptions}
              notFoundContent="No hay razones disponibles"
              style={{ width: "250px" }}
            />
          </Form.Item>
        </Form>
      ),
      okText: "Cancelar orden",
      okType: "danger",
      cancelText: "No hacer nada",
      onOk() {
        return new Promise((resolve, reject) => {
          form.validateFields()
            .then((values) => {
              cancelMonitorOrder(values.reason);
              resolve();
            })
            .catch(reject);
        });
      },
    });
  };

  const confirmTransfer = () => {
    form.resetFields();
    Modal.confirm({
      title: "¿Estás segúro de Transferir esta orden?",
      content: (
        <Form layout="vertical" form={form}>
          <p>Esta acción no se podrá deshacer.</p>
          <Form.Item
            label="Seleccione la razón de traslado:"
            name="reason"
            rules={[{ required: true, message: "Por favor seleccione una razón" }]}
          >
            <Select
              options={reasonOptions}
              notFoundContent="No hay razones disponibles"
              style={{ width: "250px" }}
            />
          </Form.Item>
        </Form>
      ),
      okText: "Transferir orden",
      okType: "danger",
      cancelText: "No hacer nada",
      onOk: () => {
        return form.validateFields().then(async (values) => {
          handleLoadTransfer(true);
          try {
            await transferOrder(selectBranch, values.reason);
          } finally {
            handleLoadTransfer(false);
          }
        });
      },
    });
  };

  const accepMonitorOrder = async () => {
    handleSending(true);
    await acceptOrder();
    handleSending(false);
  };

  const updateMonitorOrder = async () => {
    handleSending(true);
    await updateOrder();
    handleSending(false);
  };

  const finishMonitorOrder = async () => {
    handleSending(true);
    await finishOrder();
    handleSending(false);
  };

  const cancelMonitorOrder = async (reason) => {
    handleDeleting(true);
    await cancelOrder(user.id, reason);
    handleDeleting(false);
  };

  const assingMonitorOrder = async () => {
    handleAssing(true);
    await assignOrder(selectDriver);
    handleAssing(false);
  };

  const confirmAcceptOrder = () => {
    confirmModal(
      "¿Estás segúro de colocar esta orden en preparación?",
      "Esta acción no se podrá deshacer.",
      "Orden en preparación",
      accepMonitorOrder
    );
  };

  const confirmUpdateOrder = () => {
    const title = orderType === 2
      ? "¿Confirmar esta orden lista para enviar?"
      : "¿Estás segúro de colocar esta orden lista para recoger?";
    confirmModal(title, "Esta acción no se podrá deshacer.", "Orden lista", updateMonitorOrder);
  };

  const confirmFinishOrder = () => {
    confirmModal("¿Estás segúro de finalizar esta orden?", "Esta acción no se podrá deshacer.", "Orden finalizada", finishMonitorOrder);
  };

  const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hourStr, minute] = time.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // convierte 0 en 12
    return `${hour}:${minute} ${ampm}`;
  };


  return (
    <div className={styles.order}>
      <Row>
        <Col xs={24}>
          <OrderHeader status={status} orderType={orderType} ticket={ticket} hotstopArriveTime={order.hotstop_arrive_time} />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          {id_user && (
            <OrderClientInfo
              id_user={id_user}
              orderType={orderType}
              address_info={address_info}
              delivery_address={delivery_address}
              branch={branch}
            />
          )}
        </Col>
      </Row>

      {orderType === 4 && (
        (() => {
          const time12 = formatTo12Hour(order?.hotstop_arrive_time);
          const model = order?.hotstop_arrive_vehicle?.model || "";
          const colorText = order?.hotstop_arrive_vehicle?.color || "";
          const hasAny = Boolean(time12 || model || colorText);

          if (!hasAny) return null;

          return (
            <div style={{ marginTop: 12 }}>
              <Card
                size="small"
                className={styles.hotstopCard}
                bodyStyle={{ padding: 12 }}
                bordered={false}
              >
                <Space size="large" align="center" wrap>
                  <Space size={8} align="center">
                    <span className={styles.hotstopIcon} aria-hidden>🕒</span>
                    <span className={styles.hotstopLabel}>Hora de llegada:</span>
                    {time12 ? (
                      <Tag color="processing" style={{ marginInlineStart: 4 }}>
                        {time12}
                      </Tag>
                    ) : (
                      <span>—</span>
                    )}
                  </Space>

                  <Divider type="vertical" />

                  <Space size={8} align="center">
                    <span className={styles.hotstopIcon} aria-hidden>🚗</span>
                    <span className={styles.hotstopLabel}>Marca/Modelo:</span>
                    <span style={{ fontWeight: 500 }}>{model || "—"}</span>
                  </Space>

                  <Divider type="vertical" />

                  <Space size={8} align="center">
                    <span className={styles.hotstopLabel}>Color:</span>
                    <Tooltip title={colorText || "—"}>
                      <ColorSwatch colorName={colorText} />
                    </Tooltip>
                    <span style={{ fontWeight: 500 }}>{colorText || "—"}</span>
                  </Space>
                </Space>
              </Card>
            </div>
          );
        })()
      )}

      {(!cireba_remote_id || cireba_remote_id === "0") && order.status !== 6 && order.status !== 20 && (
        <div className={styles.warning}>
          <Alert message="Orden no ingresada a CIREBA" showIcon type="warning" />
        </div>
      )}

      <div className={styles.body}>
        <Row gutter={20}>
          <Col xs={24} lg={12}>
            <ProductList products={products} loadingDeta={loadingDeta} openDataCard={openDataCard} />

            {(platform === "ubereats" || platform === "pedidosya") && description && (
              <div className={styles.annotations}>
                <span>
                  <span className={styles.labelNotes}>Notas:</span> {description.replace("[UBER]", "")}
                </span>
              </div>
            )}

            {orderType === 2 && (
              <div className={styles.totalInfo}>
                <div className={styles.deliveryWrap}>
                  <span className={styles.label}>ENVÍO A DOMICILIO:</span>
                  <span className={styles.price}>{`$ ${parseFloat(delivery_fee).toFixed(2)}`}</span>
                </div>
              </div>
            )}

            {parseFloat(discount) > 0 && (
              <div className={styles.tipWrap}>
                <span className={styles.label}>DESCUENTO:</span>
                <span className={styles.price}>{`- ($ ${parseFloat(discount).toFixed(2)})`}</span>
              </div>
            )}

            {/* PROPINA */}
            {(tip && parseFloat(tip) > 0) ? 
              <div className={styles.tipWrap}>
                <span className={styles.label}>
                  PROPINA:
                </span>
                <span className={styles.price}>{`$ ${parseFloat(tip).toFixed(2)}`}</span>
              </div>
            : <></> }

            <div className={styles.totalInfo}>
              <div className={styles.totalWrap}>
                <span className={styles.label}>TOTAL DE COMPRA</span>
                <span className={cx(styles.totalPrice, styles.green)}>
                  {`$ ${parseFloat(total).toFixed(2)}`}
                </span>
              </div>
            </div>
          </Col>

          <OrderActionsSection
            styles={styles}
            isCash={isCash}
            cashback={cashback}
            change={change}
            total={total}
            monitor={monitor}
            isAdmin={isAdmin}
            status={status}
            loading={loading}
            selectBranch={selectBranch}
            handleSelectedBranch={handleSelectedBranch}
            confirmTransfer={confirmTransfer}
            branches={branches}
            isDriver={isDriver}
            orderType={orderType}
            peyaOrder={peyaOrder}
            order={order}
            drivers={drivers}
            selectDriver={selectDriver}
            handleSelectedDriver={handleSelectedDriver}
            assingMonitorOrder={assingMonitorOrder}
            assing={assing}
            id_driver={id_driver}
            sendPeya={sendPeya}
            peyaConfirmCode={peyaConfirmCode}
            peyaStatus={peyaStatus}
            peyaResult={peyaResult}
            spanish_peya={spanish_peya}
            confirmCancel={confirmCancel}
            confirmAcceptOrder={confirmAcceptOrder}
            confirmUpdateOrder={confirmUpdateOrder}
            confirmFinishOrder={confirmFinishOrder}
            deleting={deleting}
            sending={sending}
            updateManualRemoteId={updateManualRemoteId}
            updateKioskoManualStatus={updateKioskoManualStatus}
          />
        </Row>
      </div>
    </div>
  );
};

export default OrderDetail;
